var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResultCard',{attrs:{"num-uri-string":_vm.numUriString,"result":_vm.result,"as-link":false}})}
var staticRenderFns = []

export { render, staticRenderFns }